import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.formTarget.classList.add("flex")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  save(event) {
    if (event?.type === "blur" && this.element.contains(event.relatedTarget)) return

    if (this.inputTarget.value.trim() !== "") {
      this.formTarget.requestSubmit()
    } else {
      this.cancel()
    }
  }

  cancel() {
    this.formTarget.classList.add("hidden")
    this.formTarget.classList.remove("flex")
    this.displayTarget.classList.remove("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }
}
